import React from "react";
import { Outlet } from "react-router";
import PdaNavbar from "../Components/PdaNavbar/PdaNavbar";
import { useOrder } from "../Context/useOrder";
import { useAuth } from "../Context/useAuth";
import Barcode from "react-barcode";

const AuthLayout = () => {
  const { isAuthenticated } = useAuth();
  const { getCurrentOrder } = useOrder();
  const order = getCurrentOrder();
  return (
    <div>
      <div className="auth-layout">
        <PdaNavbar />
        <main role="main" className="container-fluid">
          <Outlet />
        </main>
      </div>
      {order && order.transRefCode && order.dueDate && isAuthenticated() && (
        <div className="print-only">
          {(order.accountFirstName || order.accountLastName) && (
            <div style={{ fontSize: "18px", textAlign: "center", marginTop: 5, marginBottom: 0, lineHeight: 1 }}>
              {[order.accountFirstName, order.accountLastName].filter(Boolean).join(" ")}
            </div>
          )}
          <div style={{ marginTop: 0, lineHeight: 0 }}>
            <Barcode value={order.transRefCode} format="CODE128" width={1.5} height={28} displayValue={false} margin={2} marginBottom={0} />
            <div style={{ fontSize: 20, textAlign: "center", marginTop: 2, lineHeight: 1, fontFamily: "monospace" }}>{order.transRefCode}</div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AuthLayout;
